// Translations for ScandicDev Landing Page - Professional & Dynamic

export const translations = {
  de: {
    // Navigation
    nav: {
      vorteile: "Vorteile",
      funktionen: "Funktionen",
      branchen: "Branchen",
      ablauf: "Ablauf",
      referenzen: "Referenzen",
      faq: "FAQ",
      cta: "Jetzt starten",
    },
    
    // Hero Section
    hero: {
      badge: "KI-Automatisierung für ambitionierte Unternehmen",
      headline: "KI-Agenten für Unternehmen",
      subheadline: "ScandicDev implementiert KI-Agenten für Telefon, E-Mail, Dokumente und Workflows, damit Teams im deutschen Mittelstand weniger Routine manuell bearbeiten müssen.",
      ctaPrimary: "Kostenlose Analyse sichern",
      ctaSecondary: "Leistungsseiten ansehen",
      benefit1: "Telefon, E-Mail und Dokumente entlasten",
      benefit2: "DSGVO-konforme Prozessautomatisierung",
      benefit3: "Für den deutschen Mittelstand aufgebaut",
      trust1: "Praxisnah umgesetzt",
      trust2: "Klare Freigaben und Eskalationen",
      trust3: "Integration in bestehende Systeme",
    },
    
    // Benefits Section
    benefits: {
      title: "Warum jetzt auf",
      titleHighlight: "KI setzen?",
      subtitle: "Der Fachkräftemangel verschärft sich. Personalkosten steigen. Wer heute automatisiert, sichert sich den Wettbewerbsvorteil von morgen.",
      items: [
        { title: "Routineaufwand reduzieren", description: "Automatisieren Sie repetitive Tätigkeiten und entlasten Sie Ihr Team bei Vorgängen mit klarer Wiederholbarkeit." },
        { title: "Kapazitäten besser nutzen", description: "Bearbeiten Sie mehr Anfragen, Aufträge und Vorgänge, ohne dass zusätzliche manuelle Schleifen entstehen." },
        { title: "Durchlaufzeiten verkürzen", description: "Antworten, Dokumente und Datenpflege laufen strukturierter durch Ihre bestehenden Prozesse." },
        { title: "Fehlerquote minimieren", description: "Standardisierte Prozesse bedeuten: konsistente Qualität, weniger Nacharbeit, zufriedenere Kunden." },
        { title: "Erreichbarkeit stabilisieren", description: "Kundenanfragen werden schneller aufgenommen, sortiert und an den richtigen Prozess übergeben." },
        { title: "Pragmatisch starten", description: "Wir integrieren in bestehende Infrastruktur und priorisieren die Prozesse mit dem größten Hebel." },
      ],
    },
    
    // Functions Section
    functions: {
      title: "Was Ihr KI-Agent",
      titleHighlight: "konkret leistet",
      subtitle: "Keine Theorie – echte Anwendungsfälle aus dem Tagesgeschäft.",
      hint: "Volle Kontrolle: Jede Aktion folgt Ihren Regeln und Freigabeprozessen.",
      items: [
        { title: "Telefonische Anfragen automatisiert bearbeiten", description: "Ihr KI-Agent übernimmt Telefonate für Rückrufe, Termine und einfache Anfragen – für schnellere Abläufe und weniger manuelle Routine." },
        { title: "E-Mail-Postfach managen", description: "Eingehende E-Mails analysieren, priorisieren und professionelle Antwort-Entwürfe erstellen." },
        { title: "Kundenanfragen beantworten", description: "Ob Chat, E-Mail oder Formular – Ihr Agent antwortet sofort, präzise und in Ihrem Tonfall." },
        { title: "Termine intelligent planen", description: "Verfügbarkeiten prüfen, Termine vorschlagen, Bestätigungen und Erinnerungen versenden." },
        { title: "Dokumente automatisch erstellen", description: "Angebote, Reports, Zusammenfassungen – auf Knopfdruck generiert, fehlerfrei formatiert." },
        { title: "Daten aus Dokumenten extrahieren", description: "PDFs, Rechnungen, Formulare: Relevante Daten werden erkannt und in Ihre Systeme übertragen." },
        { title: "Workflows automatisch anstoßen", description: "Tickets anlegen, CRM-Einträge aktualisieren, Follow-ups terminieren – alles automatisch." },
        { title: "Wissen sofort verfügbar machen", description: "Ihr Agent durchsucht interne Dokumente und liefert präzise Antworten in Sekunden." },
      ],
    },
    
    // Industries Section
    industries: {
      title: "In welchen Branchen",
      titleHighlight: "wir liefern",
      subtitle: "Überall, wo wiederkehrende Aufgaben Zeit und Ressourcen binden.",
      items: [
        { title: "Buchhaltung & Finance", examples: ["Belegprüfung", "Kontenabgleich", "Mahnwesen", "Reporting"] },
        { title: "Kanzleien & Rechtsberatung", examples: ["Aktenanalyse", "Fristüberwachung", "Mandantenkommunikation"] },
        { title: "Steuerberatung", examples: ["Dokumentenprüfung", "Mandantenanfragen", "Vorqualifizierung"] },
        { title: "Gesundheitswesen", examples: ["Terminkoordination", "Patientenkommunikation", "Formularassistenz"] },
        { title: "Logistik & Supply Chain", examples: ["Statusverfolgung", "Disposition", "Dokumentenmanagement"] },
        { title: "E-Commerce & Handel", examples: ["Kundensupport", "Retourenmanagement", "Produktberatung"] },
      ],
    },
    
    // Process Section
    process: {
      title: "Ihr Weg zur",
      titleHighlight: "KI-Automatisierung",
      subtitle: "Strukturiert, transparent, ergebnisorientiert – von der Analyse bis zum Go-Live.",
      cta: "Erste Analyse vereinbaren",
      steps: [
        { title: "Prozess-Analyse (kostenlos)", description: "In 45-60 Minuten identifizieren wir gemeinsam Ihre größten Automatisierungspotenziale und Quick Wins." },
        { title: "ROI-Kalkulation & Priorisierung", description: "Sie erhalten eine konkrete Wirtschaftlichkeitsberechnung – damit Sie genau wissen, was sich wann rechnet." },
        { title: "Implementierung & Go-Live", description: "Wir integrieren Ihren KI-Agenten strukturiert in Ihr Tagesgeschäft – mit klaren Zuständigkeiten und Testschritten." },
        { title: "Monitoring & Optimierung", description: "Nach dem Start optimieren wir kontinuierlich – für messbar bessere Ergebnisse Monat für Monat." },
      ],
    },
    
    // Testimonials Section
    testimonials: {
      title: "Messbare Ergebnisse",
      subtitle: "Was unsere Kunden mit KI-Agenten erreicht haben.",
      items: [
        { quote: "Reaktionszeit auf Kundenanfragen von 4 Stunden auf 12 Minuten reduziert", name: "Geschäftsführer", company: "Mittelständisches Unternehmen", result: "-82% Zeit" },
        { quote: "35% mehr Aufträge bearbeitet – ohne eine einzige Neueinstellung", name: "Operations Manager", company: "Logistikdienstleister", result: "+35% Kapazität" },
        { quote: "Fehlerquote bei Dokumenten von 8% auf unter 1% gesenkt", name: "Teamleiter Finanzen", company: "Wirtschaftskanzlei", result: "-87% Fehler" },
      ],
    },
    
    // Security Section
    security: {
      title: "Enterprise-Grade",
      titleHighlight: "Sicherheit",
      subtitle: "Ihre Daten bleiben Ihre Daten. Garantiert.",
      items: [
        "DSGVO-konforme Verarbeitung",
        "Granulares Rollen- & Rechtemanagement",
        "Lückenlose Audit-Protokollierung",
        "Mehrstufige Freigabeprozesse",
        "Datenminimierung als Prinzip",
        "ISO 27001-zertifizierte Infrastruktur",
      ],
    },
    
    // FAQ Section
    faq: {
      title: "Ihre Fragen,",
      titleHighlight: "unsere Antworten",
      items: [
        { question: "Kann ein KI-Agent auch Telefonate übernehmen?", answer: "Ja. Ein KI-Agent kann eingehende und ausgehende Telefonate übernehmen – zum Beispiel für Rückrufe, Terminabstimmungen, die Vorqualifizierung von Anfragen oder einfache Servicegespräche. So lassen sich wiederkehrende telefonische Abläufe effizienter gestalten und Teams im Tagesgeschäft spürbar entlasten." },
        { question: "Ersetzt KI unsere Mitarbeiter?", answer: "KI wird in vielen Unternehmen vor allem eingesetzt, um wiederkehrende Abläufe effizienter zu gestalten und Teams im Tagesgeschäft zu entlasten. Welche Auswirkungen das im Einzelfall hat, hängt immer von Prozessen, Rollen und dem konkreten Einsatzbereich ab. In der Praxis geht es häufig darum, manuelle Routine zu reduzieren und Mitarbeitenden mehr Zeit für wertschöpfende Aufgaben zu geben." },
        { question: "Wie schnell sehen wir Ergebnisse?", answer: "Das hängt vom Prozess, den Datenquellen und den Freigabeschritten ab. In der Analyse legen wir fest, welcher erste Anwendungsfall realistisch umgesetzt und sinnvoll gemessen werden kann." },
        { question: "Mit welchen Systemen arbeitet der KI-Agent?", answer: "Wir binden KI-Agenten an bestehende E-Mail-, CRM-, ERP-, Ticket- und Fachsysteme an, sofern passende Schnittstellen und klare Prozessregeln vorhanden sind." },
        { question: "Wer kontrolliert, was der Agent tut?", answer: "Sie. Jeder KI-Agent arbeitet nach von Ihnen definierten Regeln. Kritische Aktionen erfordern manuelle Freigabe. Alle Aktivitäten werden protokolliert und sind jederzeit nachvollziehbar." },
        { question: "Was kostet die Implementierung?", answer: "Das richtet sich nach Umfang, Integrationen und Governance-Anforderungen. In der Analyse priorisieren wir den Startumfang und leiten daraus ein belastbares Angebot ab." },
        { question: "Wie steht es um Datenschutz?", answer: "Datenschutz ist fester Bestandteil der Umsetzung. Wir planen Datenflüsse, Zugriffe, Freigaben und Protokollierung so, dass regulatorische Anforderungen und interne Vorgaben berücksichtigt werden können." },
        { question: "Brauchen wir IT-Expertise?", answer: "Nein. Wir übernehmen die komplette technische Umsetzung. Sie beschreiben Ihre Prozesse und Anforderungen – wir kümmern uns um den Rest. Ihr IT-Team wird entlastet, nicht belastet." },
        { question: "Können wir später erweitern?", answer: "Selbstverständlich. Nach erfolgreicher Implementierung des ersten Use-Cases skalieren Sie beliebig. Die meisten Kunden starten fokussiert und erweitern dann schrittweise auf weitere Prozesse." },
      ],
    },
    
    // Contact Section
    contact: {
      title: "Lassen Sie uns sprechen",
      subtitle: "Erzählen Sie uns von Ihren Herausforderungen – wir zeigen Ihnen die Lösung.",
      success: {
        title: "Anfrage erhalten!",
        message: "Wir melden uns innerhalb von 24 Stunden bei Ihnen – versprochen.",
      },
      form: {
        name: "Ihr Name",
        namePlaceholder: "Max Mustermann",
        email: "Geschäftliche E-Mail",
        emailPlaceholder: "max@unternehmen.de",
        company: "Unternehmen",
        companyPlaceholder: "Mustermann GmbH",
        industry: "Branche",
        industryPlaceholder: "Bitte wählen",
        industries: {
          buchhaltung: "Buchhaltung & Finance",
          kanzlei: "Kanzlei & Rechtsberatung",
          steuerberater: "Steuerberatung",
          medizin: "Gesundheitswesen",
          logistik: "Logistik & Supply Chain",
          ecommerce: "E-Commerce & Handel",
          andere: "Andere Branche",
        },
        process: "Welche Prozesse möchten Sie automatisieren?",
        processPlaceholder: "Z.B. E-Mail-Bearbeitung, Kundensupport, Dokumentenerstellung...",
        consent: "Ich stimme der Kontaktaufnahme zu und habe die Datenschutzhinweise gelesen.",
        submit: "Kostenlose Analyse anfordern",
      },
    },
    
    // CTA Banner
    ctaBanner: {
      title: "Bereit, Ihre Effizienz zu verdoppeln?",
      subtitle: "Starten Sie jetzt mit einer kostenlosen Prozess-Analyse. Kein Risiko, keine Verpflichtung – nur konkrete Einsparpotenziale.",
      cta: "Jetzt Analyse starten",
    },
    
    // Footer
    footer: {
      impressum: "Impressum",
      datenschutz: "Datenschutz",
      aiEthics: "KI-Ethik-Kodex",
    },
  },
  
  en: {
    // Navigation
    nav: {
      vorteile: "Benefits",
      funktionen: "Features",
      branchen: "Industries",
      ablauf: "Process",
      referenzen: "Results",
      faq: "FAQ",
      cta: "Get Started",
    },
    
    // Hero Section
    hero: {
      badge: "AI Automation for Ambitious Businesses",
      headline: "AI Agents for Companies",
      subheadline: "ScandicDev implements AI agents for phone, email, documents, and workflows so teams spend less time on repetitive operational work.",
      ctaPrimary: "Claim Your Free Analysis",
      ctaSecondary: "Explore Solution Pages",
      benefit1: "Reduce work across phone, email, and documents",
      benefit2: "GDPR-conscious process automation",
      benefit3: "Built for mid-market operations",
      trust1: "Pragmatic delivery model",
      trust2: "Clear approvals and escalation paths",
      trust3: "Integrated into existing systems",
    },
    
    // Benefits Section
    benefits: {
      title: "Why Invest in",
      titleHighlight: "AI Now?",
      subtitle: "Labor costs are rising. Talent is scarce. Companies that automate today secure tomorrow's competitive advantage.",
      items: [
        { title: "Reduce repetitive workload", description: "Automate recurring tasks and free up teams for higher-value work." },
        { title: "Use capacity better", description: "Handle more inquiries, orders, and tasks without adding unnecessary manual loops." },
        { title: "Shorten turnaround times", description: "Responses, documents, and data updates move through your workflows in a more structured way." },
        { title: "Minimize Error Rates", description: "Standardized processes mean consistent quality, less rework, and happier customers." },
        { title: "Stabilize responsiveness", description: "Customer requests are captured faster, routed properly, and handed off with more context." },
        { title: "Start pragmatically", description: "We integrate into existing infrastructure and prioritize the processes with the clearest payoff." },
      ],
    },
    
    // Functions Section
    functions: {
      title: "What Your AI Agent",
      titleHighlight: "Actually Does",
      subtitle: "No theory – real use cases from daily operations.",
      hint: "Full control: Every action follows your rules and approval processes.",
      items: [
        { title: "Handle phone inquiries automatically", description: "Your AI agent handles calls for callbacks, appointments, and simple inquiries – for faster workflows and less manual routine work." },
        { title: "Manage Email Inbox", description: "Analyze incoming emails, prioritize them, and draft professional responses automatically." },
        { title: "Answer Customer Inquiries", description: "Chat, email, or form – your agent responds instantly, precisely, and in your brand voice." },
        { title: "Schedule Appointments Intelligently", description: "Check availability, suggest times, send confirmations and reminders automatically." },
        { title: "Generate Documents Automatically", description: "Quotes, reports, summaries – created on demand, formatted flawlessly every time." },
        { title: "Extract Data From Documents", description: "PDFs, invoices, forms: Relevant data is recognized and transferred to your systems." },
        { title: "Trigger Workflows Automatically", description: "Create tickets, update CRM entries, schedule follow-ups – all without manual intervention." },
        { title: "Make Knowledge Instantly Accessible", description: "Your agent searches internal documents and delivers precise answers in seconds." },
      ],
    },
    
    // Industries Section
    industries: {
      title: "Industries Where",
      titleHighlight: "We Deliver",
      subtitle: "Anywhere repetitive tasks consume time and resources.",
      items: [
        { title: "Accounting & Finance", examples: ["Invoice Processing", "Account Reconciliation", "Collections", "Reporting"] },
        { title: "Law Firms & Legal", examples: ["Case Analysis", "Deadline Tracking", "Client Communication"] },
        { title: "Tax Advisory", examples: ["Document Review", "Client Inquiries", "Pre-Qualification"] },
        { title: "Healthcare", examples: ["Appointment Scheduling", "Patient Communication", "Form Assistance"] },
        { title: "Logistics & Supply Chain", examples: ["Status Tracking", "Dispatch Support", "Document Management"] },
        { title: "E-Commerce & Retail", examples: ["Customer Support", "Returns Management", "Product Consultation"] },
      ],
    },
    
    // Process Section
    process: {
      title: "Your Path to",
      titleHighlight: "AI Automation",
      subtitle: "Structured, transparent, results-driven – from analysis to go-live.",
      cta: "Schedule Your Analysis",
      steps: [
        { title: "Process Analysis (Free)", description: "In 45-60 minutes, we identify your biggest automation opportunities and quick wins together." },
        { title: "ROI Calculation & Prioritization", description: "You receive a concrete business case – so you know exactly what pays off and when." },
        { title: "Implementation & Go-Live", description: "We deploy your AI agent through a structured rollout with clear ownership and testing steps." },
        { title: "Monitoring & Optimization", description: "Post-launch, we continuously optimize – for measurably better results month after month." },
      ],
    },
    
    // Testimonials Section
    testimonials: {
      title: "Measurable Results",
      subtitle: "What our clients have achieved with AI agents.",
      items: [
        { quote: "Response time to customer inquiries reduced from 4 hours to 12 minutes", name: "Managing Director", company: "Mid-Market Company", result: "-82% Time" },
        { quote: "35% more orders processed – without a single new hire", name: "Operations Manager", company: "Logistics Provider", result: "+35% Capacity" },
        { quote: "Document error rate reduced from 8% to under 1%", name: "Finance Team Lead", company: "Business Consultancy", result: "-87% Errors" },
      ],
    },
    
    // Security Section
    security: {
      title: "Enterprise-Grade",
      titleHighlight: "Security",
      subtitle: "Your data stays your data. Guaranteed.",
      items: [
        "GDPR-Compliant Processing",
        "Granular Role & Access Management",
        "Complete Audit Trail",
        "Multi-Level Approval Workflows",
        "Data Minimization by Design",
        "ISO 27001-Certified Infrastructure",
      ],
    },
    
    // FAQ Section
    faq: {
      title: "Your Questions,",
      titleHighlight: "Answered",
      items: [
        { question: "Can an AI agent also handle phone calls?", answer: "Yes. An AI agent can handle incoming and outgoing phone calls – for example callbacks, appointment coordination, inquiry pre-qualification, or simple service conversations. This makes recurring phone workflows more efficient and noticeably reduces the day-to-day load on teams." },
        { question: "Will AI replace our employees?", answer: "No. AI handles repetitive routine tasks – your employees gain time for value-adding activities like consulting, customer relationships, and strategic work. It's about empowerment, not replacement." },
        { question: "How quickly will we see results?", answer: "That depends on the process, the source systems, and the approval steps involved. During the analysis, we define which first use case can be implemented and measured responsibly." },
        { question: "Which systems does the AI agent work with?", answer: "We connect AI agents to existing email, CRM, ERP, ticketing, and specialist systems when the required interfaces and process rules are in place." },
        { question: "Who controls what the agent does?", answer: "You do. Every AI agent operates according to rules you define. Critical actions require manual approval. All activities are logged and fully traceable at any time." },
        { question: "What does implementation cost?", answer: "That depends on scope, integrations, and governance requirements. In the analysis, we define a realistic starting scope and derive a grounded proposal from it." },
        { question: "What about data protection?", answer: "Data protection is part of the implementation design. We plan data flows, access controls, approvals, and logging so regulatory requirements and internal policies can be addressed properly." },
        { question: "Do we need IT expertise?", answer: "No. We handle the complete technical implementation. You describe your processes and requirements – we take care of the rest. Your IT team is relieved, not burdened." },
        { question: "Can we expand later?", answer: "Absolutely. After successful implementation of the first use case, you can scale as you wish. Most clients start focused and then gradually expand to additional processes." },
      ],
    },
    
    // Contact Section
    contact: {
      title: "Let's Talk",
      subtitle: "Tell us about your challenges – we'll show you the solution.",
      success: {
        title: "Request Received!",
        message: "We'll get back to you within 24 hours – promised.",
      },
      form: {
        name: "Your Name",
        namePlaceholder: "John Smith",
        email: "Business Email",
        emailPlaceholder: "john@company.com",
        company: "Company",
        companyPlaceholder: "Acme Inc.",
        industry: "Industry",
        industryPlaceholder: "Please select",
        industries: {
          buchhaltung: "Accounting & Finance",
          kanzlei: "Law Firms & Legal",
          steuerberater: "Tax Advisory",
          medizin: "Healthcare",
          logistik: "Logistics & Supply Chain",
          ecommerce: "E-Commerce & Retail",
          andere: "Other Industry",
        },
        process: "Which processes do you want to automate?",
        processPlaceholder: "E.g., email handling, customer support, document generation...",
        consent: "I agree to be contacted and have read the privacy policy.",
        submit: "Request Free Analysis",
      },
    },
    
    // CTA Banner
    ctaBanner: {
      title: "Ready to Double Your Efficiency?",
      subtitle: "Start now with a free process analysis. No risk, no obligation – just concrete savings potential.",
      cta: "Start Your Analysis Now",
    },
    
    // Footer
    footer: {
      impressum: "Imprint",
      datenschutz: "Privacy Policy",
      aiEthics: "AI Code of Ethics",
    },
  },
};
